module.exports = __webpack_public_path__ + "media/ACH_INVITADOS_2_NF_.4863a8aa.mp4";